<template>
    <BaseLayout>
        <div class="break-24 retail-dekstop"></div>
        <section class="ol-home-category">
            <div class="ol-wrapper ol-wrapper--large">
                <div class="retail-dekstop">
                    <img src="https://asset.morefurniture.id/MORE/retail/Retail-1920x800.webp" width="100%" style="border-radius: 8px;">
                    <div style="position: absolute; margin-top: -120px;margin-left: 81px;">
                        <a target="_blank" class="ol-btn ol-btn-wishlist" style="margin-right: 8px;font-size:20px;" href="https://www.google.com/maps/place/MORE+Furniture+Retail+Experience,+Jl.+Mayjen+HR.+Muhammad+No.33,+Pradahkalikendal,+Kec.+Dukuhpakis,+Surabaya,+Jawa+Timur+60226/@-7.2849797,112.6957791,22z/data=!4m6!3m5!1s0x2dd7fd127a8f7b81:0xf5d98ce7797aef6f!8m2!3d-7.2849594!4d112.6957295!16s%2Fg%2F11ld8f0h0p">Menuju Lokasi</a>
                        <a href="https://page.morefurniture.id/grand-opening/" target="_blank" class="ol-btn ol-btn-wishlist" style="font-size:20px;">Lihat Selengkapnya</a>
                    </div>
                </div>
                <div class="retail-mobile">
                    <img src="https://asset.morefurniture.id/MORE/retail/Retail-600x350.webp" width="100%" style="border-radius: 8px;">
                    <div style="position: absolute; margin-top: -61px;margin-left: 21px;">
                        <a target="_blank" class="ol-btn ol-btn-wishlist" style="margin-right: 8px;" href="https://www.google.com/maps/place/MORE+Furniture+Retail+Experience,+Jl.+Mayjen+HR.+Muhammad+No.33,+Pradahkalikendal,+Kec.+Dukuhpakis,+Surabaya,+Jawa+Timur+60226/@-7.2849797,112.6957791,22z/data=!4m6!3m5!1s0x2dd7fd127a8f7b81:0xf5d98ce7797aef6f!8m2!3d-7.2849594!4d112.6957295!16s%2Fg%2F11ld8f0h0p">Menuju Lokasi</a>
                        <a href="https://page.morefurniture.id/grand-opening/" target="_blank" class="ol-btn ol-btn-wishlist">Lihat Selengkapnya</a>
                    </div>
                </div>
            </div>
        </section>
        

        <BannerBottomLoading v-if="loading" />
        <BannerTop v-else :banners="bannerTop" :clickable="true" />

        <FlashsaleGroup id="flashsale" />

        <!-- ol-home-category -->
        <Categories :categories="categoriesGroup" />
        <!-- /ol-home-category -->
        
        <section class="ol-home-type-product">
            <div class="ol-wrapper ol-wrapper--large">
                <h2 class="ol-section-title">
                    <span>Belanja Sesuai <strong>Budget</strong></span>
                    <i></i>
                </h2>
                <div class="row ">
                    <div class="col-6 col-lg-3" >
                        <a href="/products/q=&price_min=0&price_max=500000">
                            <img  :src="require('@/assets/images/benefit/budget-1.jpg')" style="width:100%;"/>
                        </a>
                    </div>
                    <div class="col-6 col-lg-3" >
                        <a href="/products/q=&price_min=500000&price_max=1000000">
                            <img  :src="require('@/assets/images/benefit/budget-2.jpg')" style="width:100%;"/>
                        </a>
                    </div>
                    <div class="col-6 col-lg-3" >
                        <a href="/products/q=&price_min=1000000&price_max=2000000">
                            <img  :src="require('@/assets/images/benefit/budget-3.jpg')" style="width:100%;"/>
                        </a>
                    </div>
                    <div class="col-6 col-lg-3" >
                        <a href="/products/q=&price_min=2000000&price_max=10000000">
                            <img  :src="require('@/assets/images/benefit/budget-4.jpg')" style="width:100%;"/>
                        </a>
                    </div>
                </div>
            </div>
        </section>
        <ProductListGroup :groups="productGroups" />

        <Endorsement />

        <section class="ol-home-type-product">
            <!-- <div class="ol-wrapper ol-wrapper--large">
                <h2 class="ol-section-title">
                    <span>TOP <strong>PRODUK</strong></span>
                    <i></i>
                </h2>
                <div class="ol-home-type-product__list">
			        <ProductListBox  v-if="!loadingTopProduct" :products="topProducts.terlaris" productType="terlaris" title="TERLARIS" />
			        <ProductListBox  v-if="!loadingTopProduct" :products="topProducts.terpopuler" productType="terpopuler" title="TERPOPULER" />
			        <ProductListBox v-if="!loadingTopProduct"  :products="topProducts.terbaru"  productType="terbaru" title="TERBARU" />
                    <TopProductLoader v-if="loadingTopProduct"  qty="3"/>
                    <TopProductLoader v-if="loadingTopProduct"  qty="3"/>
                    <TopProductLoader v-if="loadingTopProduct"  qty="3"/>
                </div>
            </div> -->
            <div class="ol-wrapper ol-wrapper--large">
                <h2 class="ol-section-title">
                    <span>Produk <strong>Terakhir Terlihat</strong></span>
                    <i></i>
                </h2>
                <div class="ol-product-content ol-product-related" >
                    <!-- <h2 class="ol-section-title">
                        <span>PRODUK <strong>TERAKHIR DILIHAT</strong></span>
                            <i></i>
                    </h2> -->
                    <ProductLoader wrapclass="ol-product-content__center-list" :page="2" :qty="5" v-if="loadingLastSeen" />
                    <!-- <ProductList :products="lastSeen" v-if="!loadingLastSeen" />  -->
                    <CarouselProduct :products="lastSeen" v-if="!loadingLastSeen" carouselKey="lastseen" />
                </div>
            </div>
        </section> 

        <div id="myModal-pop" class="modal-pop" v-if="modalShow" style="display:block;">
            <div id="modal_pop_content">
                <div>
                    <a :href="modalLink">
                        <img class="pop-img" :srcset="modalImg">
                    </a>
                    
                    <div class="closemod" >
                        <div style="position: relative;">
                            <img v-on:click="hideModal()" class="circlemod" src="@/assets/images/opening/circle.png">
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </BaseLayout>
</template>

<script>

import BaseLayout from '@/components/landing/BaseLayout.vue';
import Categories from "@/components/product/Categories.vue";
import BannerTop from "@/components/home/BannerTop.vue";
import BannerBottom from "@/components/home/BannerBottom.vue";
import Inspirasi from "@/components/home/InspirasiV2.vue";
import Endorsement from "@/components/home/Endorsement.vue";
import Carousel from "component-vue-efi/src/components/carousel/SlideCarousel.vue";
import CarouselLoader from "@/components/loading/CarouselLoader";
import ProductList from "@/components/product/ProductList.vue";
import ProductListGroup from "@/components/product/ProductListGroup.vue";
import ProductFlash from "@/components/product/ProductFlash.vue"
import Flashsale from "@/components/product/Flashsale.vue";
import FlashsaleGroup from '@/components/product/FlashsaleGroup';
import ProductLoader from '@/components/loading/product/Content.vue';
import ProductListBox from "@/components/product/ProductListBox.vue";
import TopProductLoader from "@/components/loading/product/Top";
import BannerBottomLoading from "@/components/loading/BannerBottomLoading";
import CarouselProduct from '@/components/home/CarouselProduct';
import {mapActions,mapGetters} from "vuex";

export default {
    name: 'Home',
    metaInfo() {
        return{
            link: [
                {rel: 'canonical', href: window.location.origin+this.$route.fullPath}
            ]
        }
    },
    components:{
        ProductFlash,
        BaseLayout,
        Categories,
        ProductListBox,
        ProductListGroup,
        ProductList,
        ProductLoader,
        Carousel,
        CarouselLoader,
        TopProductLoader,
        BannerTop,
        BannerBottom,
        BannerBottomLoading,
        Inspirasi,
        Endorsement,
        FlashsaleGroup,
        CarouselProduct
    },
    data(){
        return {
            categories:[],
            modalShow: false,
            modalLink: null,
            modalImg:null,
            loading:false,
            loadingBottom:false,
            loadingTopProduct:false,
            loadingLastSeen:true,
        }
    },
    computed:{
        ...mapGetters("product/list",["products","topProducts","categoriesGroup"]),
        ...mapGetters("home",["bannerTop","popup","produtTerbaik","productGroups"]),
        ...mapGetters('auth', ['authenticated']),
        ...mapGetters('profile/product', ['lastSeen']),
    },
    methods:{
        ...mapActions('profile/product', ['saveProductHistory','fetchLastSeen']),
        ...mapActions("home",["fetchProductGroups", "getBanner","getPopup","getProdutTerbaik"]),
        ...mapActions("product/list",["fetchProducts","fetchTopProducts","getCategoriesGroup"]),

        setCategories(data){
            this.categories = data;
        },
        hideModal(){
            this.modalShow =false;
        },
        // jqSlickTopBanner(){
        //     // if($('.ol-hero-slider').hasClass("slick-initialized")) $(".ol-hero-slider").slick('unslick');
        //     $(".ol-hero-slider").not('.slick-initialized').slick({
        //             slidesToScroll: 1,
        //             slidesToShow: 1,
        //             dots: !0,
        //             autoplay: !0,
        //             autoplaySpeed: 5e3,
        //             arrows: !0,
        //             pauseOnFocus: !1,
        //             responsive: [{
        //                 breakpoint: 481,
        //                 settings: {
        //                     arrows: !1
        //                 }
        //             }]
        //     });
        // },
        // jqSlickBotttomBanner(){
        //     if($('.ol-home-menu-list').hasClass("slick-initialized")) $(".ol-home-menu-list").slick('unslick');
        //     $(".ol-home-menu-list").not('.slick-initialized').slick({
        //         slidesToScroll: 1,
        //         slidesToShow: 3,
        //         dots: !1,
        //         autoplay: !0,
        //         autoplaySpeed: 5e3,
        //         arrows: !0,
        //         pauseOnFocus: !1,
        //         infinite: !0,
        //         speed: 500,
        //         fade: !1,
        //         responsive: [
        //             {
        //             breakpoint: 891,
        //             settings: {
        //                 slidesToShow: 2,
        //             },
        //             },
        //             {
        //             breakpoint: 550,
        //             settings: {
        //                 slidesToShow: 1,
        //             },
        //             },
        //         ],
        //     });

        // },
        // jqSlickFlashsale(){
        //     if($('.ol-home-group-list').hasClass("slick-initialized")) $(".ol-home-group-list").slick('unslick');
        //     $(".ol-home-group-list").slick({
        //         slidesToScroll: 1,
        //         swipeToSlide: true,
        //         verticalSwiping: false,
        //         slidesToShow: 5,
        //         dots: false,
        //         autoplay: true,
        //         autoplaySpeed: 5e3,
        //         arrows: !0,
        //         pauseOnFocus: !1,
        //         infinite: false,
        //         speed: 500,
        //         fade: !1,
        //         responsive: [
        //             {
        //                 breakpoint: 1500,
        //                 settings: {
        //                     slidesToShow: 5
        //                 }
        //             },
        //             {
        //                 breakpoint: 1160,
        //                 settings: {
        //                     slidesToShow: 4
        //                 }
        //             },
        //             {
        //                 breakpoint: 748,
        //                 settings: {
        //                     slidesToShow: 3
        //                 }
        //             },
        //             {
        //                 breakpoint: 530,
        //                 settings: {
        //                     slidesToShow: 3
        //                 }
        //             },
        //             {
        //                 breakpoint: 481,
        //                 settings: {
        //                     slidesToShow: 2
        //                 }
        //         }]
        //     });
        //     // $(".ol-home-flash-list").slick({
        //     //         slidesToScroll: 1,
        //     //         slidesToShow: 5,
        //     //         dots: !1,
        //     //         autoplay: !0,
        //     //         autoplaySpeed: 5e3,
        //     //         arrows: !0,
        //     //         pauseOnFocus: !1,
        //     //         infinite: !0,
        //     //         speed: 500,
        //     //         fade: !1,
        //     //         responsive: [{
        //     //             breakpoint: 891,
        //     //             settings: {
        //     //                 slidesToShow: 4
        //     //             }
        //     //         }, {
        //     //             breakpoint: 481,
        //     //             settings: {
        //     //                 slidesToShow: 1
        //     //             }
        //     //         }]
        //     //     })
        // },
        async getLastSeen(){
            this.loadingLastSeen = true;
            if(this.authenticated) await this.saveProductHistory();
            await this.fetchLastSeen();
            this.loadingLastSeen = false;
        },
    },
    async created(){
        this.$store.commit('transaction/checkout/setOrder', null);
    },
    updated(){
        // if(this.bannerTop) this.jqSlickTopBanner();
        // if(this.bannerBottom) this.jqSlickBotttomBanner();
    },
    async mounted(){
        this.loading = true;
        this.loadingBottom = true;
        this.loadingTopProduct = true;

        const params = new URLSearchParams(window.location.search);
        if(params.has('unAuth')) {
            this.$toast.open({ message: "Sesi telah habis, silahkan login kembali", type: "info", duration: 5000, });
        }

        await this.getPopup();

        await this.getBanner('1');
        await this.getBanner('2');
        this.loading = false;

        // await this.fetchTopProducts();
        await this.fetchProductGroups();
        // this.jqSlickFlashsale();

        await this.getCategoriesGroup();

        await this.getProdutTerbaik();
        // this.jqSlickFlashsale();

        await this.getLastSeen();
        this.loadingBottom = false;
        this.loadingTopProduct = false;
    },
    watch:{
        bannerBottom: function(value){
            this.loadingBottom =false;
        },
        popup:function(value){
            // console.log(value[0]);
            if(value.length > 0){
                var data = value[0];

                this.modalImg = data.image_url;
                this.modalLink = data.link;
                if(!this.modalShow) this.modalShow = true;

                // console.log('value', value);
                // var data = value[0];
                // const now = new Date();
                // const daystart = new Date(data.duration_start);
                // const dayend = new Date(data.duration_end);

                // if(now >= daystart && now <= dayend){
                //     this.modalImg = data.image_url;
                //     if(!this.modalShow) this.modalShow = true;
                // }else if(daystart > now){
                //     const diffTime = Math.abs(daystart - now);
                //     setTimeout(() => {
                //         this.modalImg = data.image_url;
                //         if(!this.modalShow) this.modalShow=true;
                //     }, diffTime);
                // }
            }
        },
        
	}
}
</script>

<style scoped lang="css">
.ol-home-menu{
    padding-top:24px;
}

@media (max-width: 768px) {
    .ol-home-menu{
        padding-top:0px;
    }
}

.ol-btn-wishlist{
    color: #212529;
    background-color: #f8f9fa;
    border-color: #f8f9fa;
}

.retail-dekstop{
    display:block;
}

.retail-mobile{
    display:none;
}

@media(max-width:767px){
    .retail-dekstop{
        display:none;
    }

    .retail-mobile{
        display:block;
    }
}
</style>